import { useEffect } from "react";
import { focusTargetEntityId, useNexusStore } from "../store/nexusStore";
import {
  disposeObservatoryAudio,
  playObservatoryFocusTone,
  playObservatoryHoverTone,
  setObservatorySoundEnabled,
} from "./ObservatoryAudioRuntime";

export function useObservatoryAudio() {
  const enabled = useNexusStore((state) => state.soundEnabled);
  const focus = useNexusStore((state) => state.focus);
  const hovered = useNexusStore((state) => state.hoveredEntityId);
  const focusId = focusTargetEntityId(focus);

  useEffect(() => {
    setObservatorySoundEnabled(enabled);
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;
    playObservatoryFocusTone(focus.kind === "orbital" ? "orbital" : focusId ? "node" : "cosmos");
  }, [enabled, focus.kind, focusId]);

  useEffect(() => {
    if (enabled && hovered) playObservatoryHoverTone();
  }, [enabled, hovered]);

  useEffect(() => () => disposeObservatoryAudio(), []);
}
